import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const Layout = ({ children, hideFooter = false }) => (
  <div className="min-h-screen flex flex-col bg-white">
    <Navbar />
    <main className="flex-1">{children}</main>
    {!hideFooter && <Footer />}
  </div>
);

export default Layout;
